// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifyDelete: null,
  notifyFailedDelete: null
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'DELETE_DATA':
      return { 
        ...state,
        notifyDelete: action.notifyDelete // <--- store it
      }
    case 'FAILED_DELETE_DATA':
      return { 
        ...state,
        notifyFailedDelete: action.notifyFailedDelete // <--- store it
      }
    case 'CLEAR_NOTIFY_DELETE':
      return { ...state, notifyDelete: null }
    case 'CLEAR_FAILED_NOTIFY_DELETE':
      return { ...state, notifyFailedDelete: null }
    default:
      return state
  }
}

export default DataTablesReducer
